export const getProductBenefits = (productBenefits: string | null) => {
  if (!productBenefits) {
    return []
  }

  const splitedBenefits = productBenefits.split('</div>')

  // Use to deal with the case where benefits have different HTML structures
  const pairAndConcatBenefits = (benefits: string[]) => {
    const pairedBenefits: string[] = []

    for (let i = 0; i < benefits.length; i += 2) {
      const first = benefits[i]
      const second = benefits[i + 1] || ''

      pairedBenefits.push(`${first}${second}`)
    }

    return pairedBenefits
  }

  const concatedBenefits = pairAndConcatBenefits(splitedBenefits)

  const filteredBenefits = concatedBenefits.filter(
    (benefit) => benefit.trim() !== ''
  )

  return filteredBenefits.map((benefit) => {
    const image = benefit.match(/<img[^>]*src="([^"]+)"/)?.[1]
    const title = benefit.match(/<(h3|h4)[^>]*>([^<]+)<\/(h3|h4)>/)?.[2]
    const description = benefit.match(/<p[^>]*>([^<]+)<\/p>/)?.[1]

    return {
      title,
      description,
      image,
    }
  })
}
